import { render, staticRenderFns } from "./CompanyAvatar.vue?vue&type=template&id=2e5a14c9&scoped=true&"
import script from "./CompanyAvatar.vue?vue&type=script&lang=ts&"
export * from "./CompanyAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyAvatar.vue?vue&type=style&index=0&id=2e5a14c9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a14c9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixImg: require('/root/project/frontend/src/components/images/BixImg.vue').default})
